import React, { useEffect, useState } from 'react'
import { Button } from 'reactstrap'
import RenderDataModal from '../RenderModal/RenderModal'
import { Container, Row, Col } from 'reactstrap'
import { useNavigate } from 'react-router-dom'

import './DatasetTypeModal.css'

interface DatasetTypeModalProps {
  onClose: () => void
}
export const DatasetTypeModal: React.FC<DatasetTypeModalProps> = ({
  onClose
}) => {
  const navigate = useNavigate()
  const getBody = () => {
    const clickStatic = () => {
      navigate('/ui2/datasets/generate/')
    }
    const clickDynamic = () => {
      navigate('/ui2/datasets/dynamic')
    }
    return (
      <>
        <_showType />
        <DatasetTypeButton
          name="Static"
          description="A static dataset contains manually selected files. Use this option when you need precise control over the data included in the dataset"
          onClick={clickStatic}
        />
        <DatasetTypeButton
          name="Dynamic"
          description="A dynamic dataset automatically includes data based on selected filters, such as vehicle fleets, file extensions, and collection names. Dynamic datasets are used exclusively for ingress analyzers."
          onClick={clickDynamic}
        />
      </>
    )
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <RenderDataModal
      onClose={handleClose}
      title="Select Dataset Type"
      className="dataset-type-selection-modal"
    >
      <Container className="delete-selections-container">
        <Row className="delete-selections-">
          <Col>{getBody()}</Col>
        </Row>
      </Container>
    </RenderDataModal>
  )
}

const _showType: React.FC = () => {
  return (
    <span className={`dataset-type-alert ${'alert-warning'}`}>
      {'Please select the type of dataset you would like to create.'}
    </span>
  )
}

interface DatasetTypeButtonProps {
  name: string
  description?: string
  onClick: () => void
}

export const DatasetTypeButton: React.FC<DatasetTypeButtonProps> = ({
  name,
  description,
  onClick
}) => {
  return (
    <div className="m-3 dataset-button-container">
      <Row className="align-items-center">
        <Col sm="3" className="d-flex justify-content-center">
          <Button onClick={onClick} color="success" className="dataset-button">
            {name}
          </Button>
        </Col>
        <Col sm="9" className="text-left">
          <p className="dataset-description">{description}</p>
        </Col>
      </Row>
    </div>
  )
}
